import { render, staticRenderFns } from "./product-brand-add-modal.vue?vue&type=template&id=2c670bc6&scoped=true&"
import script from "./product-brand-add-modal.vue?vue&type=script&lang=js&"
export * from "./product-brand-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-brand-add-modal.vue?vue&type=style&index=0&id=2c670bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c670bc6",
  null
  
)

export default component.exports